import React, { useState, useEffect } from 'react';
import { Table, Pagination, Input, Space, message } from 'antd';
import { CiSearch } from 'react-icons/ci';
import { connect } from 'react-redux';
import Header from '../../components/Header/header';
import FormModal from '../../components/Modal/FormModal';
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
import * as Actions from '../../store/slices/blacklist/blacklist';
import style from '../notifyConfig/notifyconfig.module.css';

interface Props {
  Blacklist_Red: any;
  getBlacklisted: (page: number, size: number) => any;
  deleteBlacklisted: (id: number) => any;
}

const BlacklistPage: React.FC<Props> = ({ Blacklist_Red, getBlacklisted, deleteBlacklisted }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [searchText, setSearchText] = useState('');
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const rawData: any[] = Array.isArray(Blacklist_Red?.data) ? Blacklist_Red.data : [];
  const totalDocuments: number = Blacklist_Red?.totalDocuments ?? 0;
  console.log('[Blacklist] Redux state:', Blacklist_Red);

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const fetchData = async (page: number, size: number) => {
    setLoading(true);
    await getBlacklisted(page, size);
    setLoading(false);
  };

  const handleDelete = (record: any) => {
    setSelectedId(record.id);
    setDeleteOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedId) return;
    const res = await deleteBlacklisted(selectedId);
    setDeleteOpen(false);
    setSelectedId(null);
    if (res?.success) {
      message.success('Blacklist entry deleted');
      fetchData(currentPage, pageSize);
    } else {
      message.error(res?.message || 'Failed to delete');
    }
  };

  const filteredData = rawData.filter((item: any) =>
    item.customerIdentifier?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.comments?.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Customer Identifier',
      dataIndex: 'customerIdentifier',
      key: 'customerIdentifier',
      width: 200,
    },
    {
      title: 'Comments',
      dataIndex: 'comments',
      key: 'comments',
      width: 250,
      render: (v: string) => v || '-',
    },
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: 120,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      render: (v: string) => v ? new Date(v).toLocaleString() : '-',
    },
    {
      title: 'Action',
      key: 'action',
      width: 80,
      render: (_: any, record: any) => (
        hasPermission(PERMISSIONS.BLACKLIST_DELETE) ? (
          <span
            style={{ color: '#ff4d4f', cursor: 'pointer', fontSize: 13 }}
            onClick={() => handleDelete(record)}
          >
            Delete
          </span>
        ) : null
      ),
    },
  ];

  return (
    <>
      <Header />
      <FormModal
        modalTitle="Delete Blacklist Entry"
        Subtitle="Are you sure you want to remove this entry from the blacklist?"
        open={deleteOpen}
        setOpen={setDeleteOpen}
        onOk={confirmDelete}
        onCancel={() => { setDeleteOpen(false); setSelectedId(null); }}
        okText="Delete"
        cancelText="Cancel"
      />
      <div className={style.Route}>
        <h5>Blacklisted Winners</h5>
      </div>
      <div className={style.container}>
        <Space className={style.SearchTable}>
          <div className={style.SearchBar}>
            <Input
              placeholder="Search..."
              prefix={<CiSearch size={20} />}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 220 }}
              className={style.inputSearch}
            />
          </div>
        </Space>
        <Table
          loading={loading}
          columns={columns}
          dataSource={filteredData.map((item: any) => ({ ...item, key: item.id }))}
          pagination={false}
          size="small"
        />
        <Pagination
          align="end"
          showTotal={(total) => `Total ${total} items`}
          current={currentPage + 1}
          total={totalDocuments}
          pageSize={pageSize}
          pageSizeOptions={[12, 24, 50]}
          showSizeChanger
          onChange={(page, size) => {
            if (size !== pageSize) {
              setCurrentPage(0);
              setPageSize(size);
            } else {
              setCurrentPage(page - 1);
            }
          }}
          style={{ marginTop: 16 }}
        />
      </div>
    </>
  );
};

function mapStateToProps(state: any) {
  return { Blacklist_Red: state.Blacklist_Red };
}

export default connect(mapStateToProps, Actions)(BlacklistPage);
